import React from 'react'
import { useParams } from 'react-router-dom'

import { FlowDetail } from '@/containers/FlowDetail'
import { FlowDetailShape } from '@/contexts/FlowContext'

const FlowDetailPage: React.FC = () => {
    const { flowId = '' } = useParams()

    return <FlowDetail id={flowId} shape={FlowDetailShape.PAGE} />
}

export default FlowDetailPage
